/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Access Administration API
 * OpenAPI spec version: 1.0.0
 */
import type {
  ListAccessAdministrationPermissionsParams,
  PaginatedPermissionDto,
  PermissionDto,
} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getListAccessAdministrationPermissionsUrl = (
  params: ListAccessAdministrationPermissionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/access-administration/permissions?${stringifiedParams}`
    : `/api/v1/access-administration/permissions`;
};

/**
 * @summary List permissions
 */
export const listAccessAdministrationPermissions = async (
  params: ListAccessAdministrationPermissionsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedPermissionDto> => {
  return customFetch<PaginatedPermissionDto>(getListAccessAdministrationPermissionsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetAccessAdministrationPermissionUrl = (permissionKey: string) => {
  return `/api/v1/access-administration/permissions/${permissionKey}`;
};

/**
 * @summary Get permission
 */
export const getAccessAdministrationPermission = async (
  permissionKey: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<PermissionDto> => {
  return customFetch<PermissionDto>(getGetAccessAdministrationPermissionUrl(permissionKey), {
    ...options,
    method: "GET",
  });
};
